import React from "react";
import { motion } from "framer-motion";

/**
 * MaskedLines — signature masked line-by-line reveal.
 * Each line rises out of an overflow mask with a soft rotation,
 * staggered like pages being turned. Lines may be strings or nodes.
 */
export default function MaskedLines({
  lines,
  as: Tag = "div",
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.13,
  once = true,
  animateOn = "inView", // "inView" | "mount"
  ...rest
}) {
  const linesArray = Array.isArray(lines) ? lines : [lines];
  return (
    <Tag className={className} {...rest}>
      {linesArray.map((line, i) => (
        <span
          key={i}
          className="block overflow-hidden pb-[0.09em] -mb-[0.09em]"
        >
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: "112%", rotate: 2.5, opacity: 0 }}
            {...(animateOn === "mount"
              ? { animate: { y: "0%", rotate: 0, opacity: 1 } }
              : {
                  whileInView: { y: "0%", rotate: 0, opacity: 1 },
                  viewport: { once, margin: "-12% 0px" },
                })}
            transition={{
              duration: 1.15,
              delay: delay + i * stagger,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
